/**
 * @generated SignedSource<<bb64ef0c0a39bbb2a1e944b0275a9281>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addPricingRulePanel_AssignMutation$variables = {
  pricingId: string;
  productIds: ReadonlyArray<number>;
};
export type addPricingRulePanel_AssignMutation$data = {
  readonly assignProductsToPricing: {
    readonly result: boolean;
  };
};
export type addPricingRulePanel_AssignMutation = {
  response: addPricingRulePanel_AssignMutation$data;
  variables: addPricingRulePanel_AssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pricingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pricingId",
        "variableName": "pricingId"
      },
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToPricing",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addPricingRulePanel_AssignMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addPricingRulePanel_AssignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1d5a2b8ddf9e23044e740c3da9db86a3",
    "id": null,
    "metadata": {},
    "name": "addPricingRulePanel_AssignMutation",
    "operationKind": "mutation",
    "text": "mutation addPricingRulePanel_AssignMutation(\n  $pricingId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToPricing(pricingId: $pricingId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "43c2bb95f25d06ae8d8fbfde85554fa6";

export default node;
